import EmberObject, { computed } from '@ember/object';

export default EmberObject.extend({
  isLast: computed('filterConfig.filterGroups.[]', function () {
    return this.get('filterConfig.filterGroups.lastObject.id') === this.id;
  }),
});
